import * as React from 'react';

export const handleLinkClick = (e: React.MouseEvent, url: string) => {
  if (!url) {
    return;
  }

  e.preventDefault();
  window.open(url, '_blank');
};
